export const HEADER_HEIGHT = 92;
export const HEADER_HEIGHT_SMALL = 50;
export const HEADER_LOGO_WIDTH_DESKTOP = 118;
export const HEADER_LOGO_HEIGHT_DESKTOP = 53;
export const HEADER_LOGO_WIDTH_DESKTOP_SMALL = 75;
export const HEADER_LOGO_WIDTH_MOBILE = 120;
